export const passwordRegex = /^[*#]*\d*[*#]*$/
export const entryPasswordRegex = /[\{\}\[\]\/?.,;:|\)~`!^\-_+<>@\$%&\\\=\(\'\"]$/
